<template>
  <div class="container">
    <h3 class="title">Wybierz usługę</h3>
    <div class="btn-group" v-for="(eq, i) in ServiceTypeList" :key="i">
      <button
        type="button"
        class="btn full"
        :style="{ background: $color }"
        @click="btnHandler(eq.k)"
      >{{eq.v}}</button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "StepOtherService",
  methods: {
    ...mapMutations(["setUserData", "setAssistanceStep"]),
    btnHandler(ServiceType) {
      this.setUserData({ ServiceType });
      this.setAssistanceStep("additional");
    },
  },
  computed: {
    ...mapState(["ServiceTypeList"]),
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepOtherService.vue